<template>
  <a href="#" onclick="FB.CustomerChat.showDialog()" class="text-primary">Any Questions?</a>
</template>

<script>
export default {};
</script>

<style>
</style>